<template>
  <transition name="modal">
    <div class="modal">
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header"></slot>
        </div>
        <button class="close" @click="$emit('close')">x</button>
        <div class="text">
          <slot name="body"></slot>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    name: "Modal"
  }
</script>

<style>
  .modal {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    transition: opacity .3s ease;
  }

  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 60%;
    position: relative;
  }

  @media (max-width: 425px) {
    .modal-content {
      width: 90vw;
    }
  }

  .text {
    color: black;
    text-align: center;
    vertical-align: center;
    margin: 30px auto;
    width: 90%;
  }

  .close {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
    position: absolute;
    z-index: 1;
    top: 10px;
    right: 20px;
    border: 0;
    padding: 5px 10px;
  }

  @media (max-width: 425px) {
    .close {
      background-color: unset;
    }
  }

  .close:hover,
  .close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }

  .modal-header {
    font-family: 'Tw Cen MT';
    letter-spacing: 2px;
    font-size: 26px;
    color: #031D24;
    margin-top: 20px;
  }

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal,
  .modal-leave-active .modal {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>